import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export default function UseCheckStatusAdmin() {
  const orgId = useSelector((state) => state.roleReducer.role)
  const profile = useSelector((state) => state.loginReducer.profile)

  const [data, setData] = useState()
  useEffect(() => {
    if (profile.roles && orgId) {
      const newFirst = profile.roles.find(
        (d) => d.org_id.toString() === orgId.toString()
      )
      setData(newFirst)
    }
  }, [profile, orgId])

  return data
}
